module.exports = __webpack_public_path__ + "img/storyboard_lite_widgets.01456f38.webp";